// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{background:#f5f5f5}#app{padding:54px}@media screen and (max-width:480px){#app{padding:13.5px}}.ewc-project-contact-form,.ewc-project-documents,.ewc-project-inventory{width:650px;max-width:100%;margin-bottom:54px}", ""]);
// Exports
module.exports = exports;
